import React from "react";
import '../footer/footer.css';
import logo from './image/logo-logomark.png';
import facebook from './image/Vector (4).png';
import twiter from './image/Vector (5).png';
import insta from './image/Vector (6).png';
import utube from './image/ps_youtube (1).png';

function footer(){
    return(
        <div className="footer">
            <div className="logo-fot">
            <img src={logo} alt="" />
            </div>
            <div className="list-fot">
                <a href="#">Home</a>
                <a href="#">About Us</a>
                <a href="#">Contact Us</a>
            </div>
            <div className="logo-social">
                <img src={facebook} alt="" />
                <img src={twiter} alt="" />
                <img src={insta} alt="" />
                <img src={utube} alt="" />
            </div>
            <div className="para-fot">
                <p>© 2025 MyApp. All Rights Reserved.</p>
            </div>
        </div>
    );
}
export default footer;